import { isPromotionalDiscount } from 'pricing-pages-ui-hsoc/components/merch-card-grid/hsocCardBadges';
import { useGrowthPopPurchaseOptions } from '../../bundle/hooks/useGrowthPurchaseOptions';

/*
 * Public-app counterpart of pricing-pages-ui's useUpsellDiscountPercentageForTerm.
 */
export function useHsocPublicUpsellDiscountForTerm(productApiName, {
  term,
  skip = false
}) {
  var _products$productApiN, _option$listPrice, _option$discounts;
  const {
    products,
    loading
  } = useGrowthPopPurchaseOptions({
    productsToPurchase: [{
      productApiName,
      quantity: 1
    }],
    skip
  });
  if (loading || !products) {
    return null;
  }
  const option = (_products$productApiN = products[productApiName]) === null || _products$productApiN === void 0 || (_products$productApiN = _products$productApiN.purchaseOptions) === null || _products$productApiN === void 0 ? void 0 : _products$productApiN[term];
  const price = option !== null && option !== void 0 && option.monthlyPrice ? Number(option.monthlyPrice) : null;
  const listPrice = option !== null && option !== void 0 && (_option$listPrice = option.listPrice) !== null && _option$listPrice !== void 0 && _option$listPrice.monthlyPrice ? Number(option.listPrice.monthlyPrice) : null;
  if (!price || !listPrice || listPrice <= price) {
    return null;
  }

  /* Only surface a discount that comes from an actual promotion, never the
   * baseline annual payment discount. */
  const hasPromotion = option === null || option === void 0 || (_option$discounts = option.discounts) === null || _option$discounts === void 0 ? void 0 : _option$discounts.some(isPromotionalDiscount);
  if (!hasPromotion) {
    return null;
  }
  const pct = Math.round((listPrice - price) / listPrice * 100);
  return pct > 0 ? pct : null;
}